import { AxiosResponse } from "axios";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  addCampaignToCampaigns,
  setCampaignActionStart,
  setCampaignErrorMessage,
} from "../../constants/reducers/campaign.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { CreateCampaignDTO } from "../../constants/dto/campaign";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";

let body: CreateCampaignDTO;

export const createCampaign = async () => {
  store.dispatch(setCampaignActionStart(true));
  const {
    picture,
    validFrom,
    validTo,
    subtitle,
    inviteSent,
    name,
    description,
    privateCampaign,
    selectedId,
    score,
    childScore,
    mixedScore,
    occasion,
    campaignType,
  } = store.getState().campaign;

  const formData = new FormData();
  if (picture) {
    formData.append("picture", picture);
  }
  if (
    validFrom !== null &&
    validTo !== null &&
    new Date(validFrom) < new Date(validTo)
  ) {
    formData.append("validFrom", validFrom);
    formData.append("validTo", validTo);
  } else {
    setCampaignErrorMessage(TextEnum.INVALID_PARAMETERS);
    return;
  }
  const goalParams = {
    score,
    childScore,
    inviteSent,
    mixedScore,
    occasion,
  };
  formData.append("type", campaignType.toString());
  formData.append("name", name);
  formData.append("subtitle", subtitle);
  formData.append("description", description);
  formData.append("goal", JSON.stringify(goalParams));
  formData.append("privateCampaign", privateCampaign.toString());
  if (selectedId) {
    formData.append("companyId", selectedId.toString());
  }

  const request = await createCall(
    "cms/campaigns/create",
    BASE_METHODS.POST,
    "multipart/form-data",
    "2.0.0",
    formData,
    undefined
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(CreateCampaignDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setCampaignErrorMessage(TextEnum.CREATE_CAMPAIGN_INVALID_RESPONSE)
      );
      return;
    }
    store.dispatch(
      addCampaignToCampaigns({ campaign: response.data.campaign })
    );
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 2001:
          errorMessage = TextEnum.CREATE_CAMPAIGN_COMPANY_NOT_FOUND;
          break;
        case 8002:
          errorMessage = TextEnum.CREATE_CAMPAIGN_CAMPAIGN_NOT_FOUND;
          break;
        case 8011:
          errorMessage = TextEnum.CREATE_CAMPAIGN_CAMPAIGN_ALREADY_EXIST;
          break;
        case 8012:
          errorMessage = TextEnum.CREATE_CAMPAIGN_INVALID_DATE;
          break;
        case 9001:
          errorMessage = TextEnum.CREATE_CAMPAIGN_FILE_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setCampaignErrorMessage(errorMessage));
      return;
    }
    store.dispatch(setCampaignActionStart(false));
    store.dispatch(timeoutError());
    return;
  }
};
